var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,255.5c.3-5.5,3.1-10.6,5.9-15.4,29-49.7,65.9-95.8,113.4-128.3,47.5-32.5,106.4-50.5,163.3-42,47.2,7,90.3,31.6,126.6,62.5,34.8,29.6,64.2,65.5,86.6,105.3,3.5,6.3,7,13.2,6.6,20.4-.3,5.9-3.2,11.3-6.1,16.5-17.6,30.9-39.1,59.6-64.1,85-43.1,43.9-98.4,78.8-159.6,84.9-59.4,5.9-118.9-16.2-165.6-52.1-41.8-32.1-76.5-74.4-101.7-120.5-2.6-4.8-5.2-10-5.2-15.5,0-.2,0-.5,0-.7ZM239.6,110.4c-81.2,6.3-152.5,79.1-190.2,146.4,50.2,86.5,140.7,168.3,248.8,141.1,70.1-17.6,128.9-80.9,163.4-141.7-46.5-79-123-153.5-222-145.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5,173.3c84.2-8.6,128.4,93.5,65.5,147.1-61.4,52.3-154-4.1-136.2-83.1,7.3-32.5,37.2-60.5,70.7-63.9ZM252.4,214.5c-59.8,4.8-44.6,97,13,82.8,50.1-12.3,37.2-86.8-13-82.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon2);
export default __webpack_public_path__ + "static/media/eye-icon-2.d78b9089a2db4e14be3891d83bb70296.svg";
export { ForwardRef as ReactComponent };